import React from 'react';
import { Text, StyleSheet, Platform } from 'react-native';
import Fonts from 'src/core/utils/Fonts';
import Dimens from 'src/core/utils/Dimens';
import Colors from 'src/core/utils/Colors';
import type { ApiContentBlockTitle } from 'src/core/models/api/ApiContentBlock';

interface ContentBlockTitleProps {
	data: ApiContentBlockTitle;
}

export default function ContentBlockTitle({ data }: ContentBlockTitleProps) {
	return <Text style={styles.text}>{data.name}</Text>;
}

const styles = StyleSheet.create({
	text: {
		fontFamily: Fonts.montserratMedium,
		fontSize: Platform.OS === 'ios' ? Dimens.fontSize20 : Dimens.fontSize17,
		color: Colors.greyHeader,
		paddingLeft: Platform.OS === 'ios' ? Dimens.padding20 : Dimens.padding16,
		paddingRight: Platform.OS === 'ios' ? Dimens.padding20 : Dimens.padding16,
		paddingTop: Platform.OS === 'ios' ? Dimens.padding15 : 13,
		paddingBottom: Platform.OS === 'ios' ? Dimens.padding5 : Dimens.padding5,
	},
});
